import { render } from "./previewData.vue?vue&type=template&id=b12c0d24"
import script from "./previewData.vue?vue&type=script&lang=js"
export * from "./previewData.vue?vue&type=script&lang=js"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__